module.exports = __webpack_public_path__ + "img/portfolio-06.b5d20da3.jpg";